import type { IBlockchain, IHistoryItem } from '@tacans/shared-marketplace-layer';
import React from 'react';
import { ActivityDate } from 'src/features/common/activity/components/activity-date';
import { ActivityLabel } from 'src/features/common/activity/components/activity-label';
import { WalletColumn } from 'src/features/common/activity/components/activity-row/wallet-column';
import Currency from 'src/features/common/currency/components/currency/currency';
import { Table } from 'src/ui/common/molecules/table';
import { StyledRow } from './styles';

interface Props {
    blockChainId: IBlockchain['id'];
    historyItem: IHistoryItem;
}

export const ActivityRow: React.VFC<Props> = ({ historyItem, blockChainId }) => {
    const { transactionHash, type, createdAt, nanoAmount, from, to } = historyItem;

    return (
        <StyledRow>
            <Table.Col>
                <WalletColumn text={transactionHash} />
            </Table.Col>
            <Table.Col>
                <ActivityLabel type={type} />
            </Table.Col>
            <Table.Col>
                <ActivityDate date={createdAt} />
            </Table.Col>
            <Table.Col>
                <Currency nanoPrice={nanoAmount} blockchainId={blockChainId} testId="activity-item-price" />
            </Table.Col>
            <Table.Col>
                <WalletColumn text={from} />
            </Table.Col>
            <Table.Col>
                <WalletColumn text={to} />
            </Table.Col>
        </StyledRow>
    );
};
